<template>
  <v-container fluid class="pa-5 pb-16 elevation-1">
    <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
      <h1 class="text-h4 font-weight-bold d-flex">
        <v-btn icon color="blue">
          <v-icon>mdi-currency-usd</v-icon>
        </v-btn>
        <span class="ml-2">Límites por Usuario</span>
        <!-- <v-btn
          :disabled="loading"
          class="btn-refresh pa-2 ml-auto"
          @click="cargar"
        >
          {{ loading ? "Actualizando..." : "Actualizar" }}
        </v-btn> -->
      </h1>
    </v-sheet>

    <div v-if="error" class="alert">{{ error }}</div>

    <v-table v-if="usuarios.length">
      <thead>
        <tr>
          <th>Usuario</th>
          <th>Email</th>
          <th>Gastado</th>
          <th>Límite USD</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in pagedRegister" :key="u.id">
          <td>
            <b>{{ u.username }}</b>
          </td>
          <td>{{ u.email || "—" }}</td>
          <td>${{ Number(u.total_spent || 0).toFixed(4) }}</td>

          <!-- Vista normal -->
          <td v-if="editando !== u.id">${{ Number(u.limit_usd || 0).toFixed(2) }}</td>
          <!-- Vista en edición -->
          <td v-else>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model.number="nuevoLimite"
              class="input-num"
            />
          </td>

          <td>
            <template v-if="editando !== u.id">
              <button class="btn-sm" @click="editar(u)">Editar</button>

              <button
                class="btn-sm btn-danger"
                @click="dialogUserDelete(u)"
                :disabled="Number(u.total_spent || 0) === 0"
              >
                Resetear
              </button>
            </template>
            <template v-else>
              <button
                class="btn-sm btn-primary"
                @click="guardar(u)"
                :disabled="guardando"
              >
                {{ guardando ? "..." : "Guardar" }}
              </button>
              <button class="btn-sm" @click="cancelar">Cancelar</button>
            </template>
          </td>
        </tr>
      </tbody>
    </v-table>
    <!-- FOOTER / PAGINACIÓN -->
    <div
      class="d-flex align-center justify-space-between flex-wrap ga-3 px-4 pb-4 table-footer"
    >
      <div class="d-flex align-center ga-2">
        <span class="text-caption text-medium-emphasis">{{
          $t("paginacion")
        }}</span>

        <v-select
          v-model="itemsPerPage"
          :items="[5, 10, 15, 20]"
          density="compact"
          variant="outlined"
          hide-details
          class="items-select"
          style="max-width: 110px"
        />
      </div>

      <v-pagination
        v-model="page"
        :length="pageCount"
        density="comfortable"
        :total-visible="6"
      />
    </div>
    <!-- <p v-else-if="!loading">No hay usuarios.</p> -->
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <DeleteInfo
          message="Borrar todo el consumo de Usuario, Reiniciando su contador en cero"
          mainValue="Eliminacion"
          warningText="Se eleminaran los registros"
          ,
          :details="[{ label: 'Usuario', value: usuario }]"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="dialog = false">Cancelar</v-btn>
          <v-btn color="red" @click="reset()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import {
  getUsersLimit,
  updateLimitUser,
  deletedUsageUser,
} from "@/api/usoModel";
import { swal } from "@/utils/swal";
import DeleteInfo from "@/components/delete/DeleteGlobalModal.vue";

const usuarios = ref([]);
const loading = ref(true);
const error = ref("");
const itemsPerPage = ref(10);
const page = ref(1);
const dialog = ref(false);
const userToReset=ref(null)
const usuario=ref("")

// Edición inline
const editando = ref(null); // user_id que se está editando
const nuevoLimite = ref(0);
const guardando = ref(false);
async function reset() {
  dialog.value = true;
  try {
    const data = await deletedUsageUser(userToReset.value);
    await swal({
        icon: "success",
        title: "Reset Exitoso",
        text:`${data.mensaje}. Filas borradas: ${data.filas_borradas}` ,
        timer: 2500,

        showConfirmButton: false,
        customClass: {
          popup: this.isDark ? "mi-popup" : "mi-popup-2",
          title: "mi-titulo",
        },
      });
    
    await cargar();
    dialog.value=false
  } catch (e) {
     await swal({
          icon: "error",
          title: this.$t("error"),
          text: "Error al resetear " + (e.response?.data?.detail || e.message),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
   
  }
}
async function cargar() {
  loading.value = true;
  try {
    const { data } = await getUsersLimit();
    usuarios.value = data;
  } catch (e) {
    error.value =
      e.response?.status === 403
        ? "No tienes permisos de administrador"
        : "Error al cargar usuarios";
  } finally {
    loading.value = false;
  }
}
function dialogUserDelete(u){
  userToReset.value=u
  usuario.value=u.username
  dialog.value=true
}
function editar(u) {
  editando.value = u.id;
  nuevoLimite.value = u.limit_usd;
}

function cancelar() {
  editando.value = null;
}

async function guardar(u) {
  guardando.value = true;
  try {
    updateLimitUser(u, nuevoLimite.value);

    editando.value = null;
     await swal({
      icon: "success",
      title: "Límite guardado",
      timer: 2000,
      showConfirmButton: false,
    });
    await cargar();
  } catch (e) {
    alert(
      "Error al guardar: " + (e.response?.data?.limit_usd?.[0] || e.message),
    );
  } finally {
    guardando.value = false;
  }
}

onMounted(cargar);

const pageCount = computed(() => {
  const total = usuarios.value.length;
  const per = Number(itemsPerPage.value) || 10;

  return Math.max(1, Math.ceil(total / per));
});
const pagedRegister = computed(() => {
  const per = Number(itemsPerPage.value) || 10;
  const start = (page.value - 1) * per;
  return usuarios.value.slice(start, start + per);
});
</script>

<style scoped>
.admin {
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
  font-family: system-ui, sans-serif;
  color: #1f2937;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
h1 {
  font-size: 24px;
  margin: 0;
}

button {
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  cursor: pointer;
  font-size: 14px;
}
.btn-sm {
  padding: 4px 10px;
  font-size: 13px;
  margin-right: 4px;
}
.btn-primary {
  background: #1e40af;
  color: white;
  border-color: #1e40af;
}
button:disabled {
  opacity: 0.6;
  cursor: wait;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  font-size: 14px;
}
th,
td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
}
th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
}
tr:last-child td {
  border-bottom: none;
}

.input-num {
  width: 100px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
}
.btn-refresh {
  background: #d0d5e6;
  color: rgb(30, 29, 29);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}
.btn-refresh:disabled {
  opacity: 0.6;
  cursor: wait;
}

.alert {
  background: #fee2e2;
  color: #991b1b;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 16px;
}
</style>
